import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiPalletsList } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/pallets/getData', async datas => {
    const { data } = await apiPalletsList(datas)
    return data
})

export const palletsSlice = createSlice({
    name: 'admin/pallets',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            collection_point_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setCollectionPoint: (state, { payload }) => {
            state.table.page = 1
            state.table.collection_point_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
    },
})

export const { setData, setTableData, setCollectionPoint } = palletsSlice.actions

export default palletsSlice.reducer
